/**
 * Created by luis on 19/07/17.
 */

/**
 * How does tracking work
 * 1. On squeeze page
 * On page load, one session ID will be created, the tracking script will send this
 *
 * 2. On popup
 * On appear, create a session ID associated with the popup, use this session to track further
 * actions
 *
 * 3. On widget
 * On element visible, send hit with session ID
 */


/**
 * send on page load, popup showed, widget visible
 * @param pageID: pageID in case of page, option ID in case of popup and wiget
 * @param sessionID
 * @param pageType: page or popup or widget
 * @param eventName: page open or page close
 */
function c37TrackingPageOpen(pageID, sessionID, pageType)
{
    console.log('sending open request');
    //send ajax post
    //send ajax post
    jQuery.post(ajaxurl, {
        pageID: pageID,
        pageType: pageType,
        eventName: 'open',
        sessionID: sessionID,
        receivedElement: 'whole_page',//action name is available on element click
        action: 'wplx_save_hit',
        url: window.location.href

    }, function(response){
        console.log(response);
    });
}

function c37TrackingPopupOpen(pageID, sessionID, pageType)
{
    console.log('sending open popup request');
    //send ajax post
    //send ajax post
    jQuery.post(ajaxurl, {
        pageID: pageID,
        pageType: pageType,
        eventName: 'open',
        sessionID: sessionID,
        receivedElement: 'whole_popup',//action name is available on element click
        action: 'wplx_save_hit',
        url: window.location.href

    }, function(response){
        console.log(response);
    });
}


function c37TrackingPopupClose(pageID, sessionID)
{
    console.log('sending close popup request');

    //send ajax post
    //send ajax post
    jQuery.post(ajaxurl, {
        pageID: pageID,
        pageType: 'popup',
        eventName: 'close',
        sessionID: sessionID,
        receivedElement: 'whole_popup',//action name is available on element click
        action: 'wplx_save_hit',
        url: window.location.href

    }, function(response){
        console.log(response);
    });
}


/**
 * send on page unload, popup closed
 * @param pageID: pageID in case of page, option ID in case of popup and wiget
 * @param sessionID
 * @param pageType: page or popup or widget
 * @param eventName: page open or page close
 */
function c37TrackingPageClose(pageID, sessionID, pageType)
{
    //send ajax post
    jQuery.post(ajaxurl, {
        pageID: pageID,
        pageType: pageType,
        eventName: 'close',
        sessionID: sessionID,
        receivedElement: 'whole_page',//action name is available on element click
        action: 'wplx_save_hit',
        url: window.location.href

    }, function(response){
        console.log(response);
    });
}

//pageID: parent.parentID,
//    pageType: parent.parentType,
//    eventName: 'click',
//    sessionID: sessionID,
//    actionName: actionName,
//    url: window.location.href,
//    action: 'wplx_save_hit'


/**
 *
 * @param element: the element that got clicked
 * @param elementName: name of the clicked element, set by user, in case of close button of popup
 * it is set to 'close-popup'
 */
function c37SendClick(element, elementName)
{
    if (typeof elementName == 'undefined')
        elementName = element.attr('c37-element-name');
    var sessionID = getSessionID(element);
    var parent = getParent(element);
    console.log('parent is', parent);

    if (parent === false || parent == {})
    {
        console.log('invalid parent object');
        return;
    }

    //send action
    jQuery.post(ajaxurl, {
        pageID: parent.parentID,
        pageType: parent.parentType,
        eventName: 'click',
        sessionID: sessionID,
        receivedElement: elementName,
        url: window.location.href,
        action: 'wplx_save_hit'
    }, function(response) {
        console.log('response');
    });
}

/**
 * the sessionID is associated with a parentID. We can get the sessionID by parentID
 * this is the trackingObject
 * {
 *  parentID_1: sessionID_1,
 *  parentID_2: sessionID_2
 * }
 * @param element
 * @returns {boolean}
 */
function getSessionID(element)
{
    if (typeof trackingObject != 'undefined')
    {
        var parentID = '';
        //check if the element is child of a popup
        if (element.closest('[data-popup-option-id]').length > 0)
        {
            parentID = element.closest('[data-popup-option-id]').attr('data-popup-option-id');
        } else if (element.closest('.c37-lp-popup-outer').length > 0)
        {
            parentID = element.closest('[data-widget-option-id]').attr('data-widget-option-id');
        } else if (element.closest('[data-page-id]').length > 0)
        {
            parentID = element.closest('[data-page-id]').attr('data-page-id');
        }

        console.log('parent ID is ', parentID);

        if (typeof trackingObject[parentID] == 'undefined')
            return false;

        return trackingObject[parentID];
    }

    return false;
}

function c37GenerateSessionID()
{
    return 'session-' + Math.round(Math.random() * 462020) + '-'+ Math.round(Math.random() * 512020) + '-' + Math.round(Math.random() * 92020);
}
//return an object of parent type and parent id
function getParent(element)
{
    console.log('finding parent');
    console.log('tracking object is: ', typeof trackingObject);
    if (typeof trackingObject != 'undefined')
    {
        var parentType= '';
        var parentID = '';
        //check if the element is child of a popup
        if (element.closest('[data-popup-option-id]').length > 0)
        {
            console.log('closest element is popup');
            parentType = 'popup';
            parentID = element.closest('[data-popup-option-id]').attr('data-popup-option-id');
        } else if (element.closest('.c37-lp-popup-outer').length > 0)
        {
            console.log('closest element is widget');
            parentType = 'widget';
            parentID = element.closest('[data-widget-option-id]').attr('data-widget-option-id');
        } else if (element.closest('[data-page-id]').length > 0)
        {
            parentType = 'page';
            parentID = element.closest('[data-page-id]').attr('data-page-id');
        } else
        {
            console.log('closest element is nobody');
        }


        console.log('parent ID is ', parentID);

        if (typeof trackingObject[parentID] == 'undefined')
            return false;

        return {
            parentType: parentType,
            parentID: parentID
        }
    }

    return {};
}


jQuery(function(){
    //tracking click action on every element with c37-action-name
    jQuery(document).on('click', '[c37-action-name]', function(){
        //get the right session ID and send
        c37SendClick(jQuery(this));
    });

});

